import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ModalComponent } from '../../layout/modals/ModalComponent';
import { FormField } from '../../layout/form-fields/FormField';
import { tagStore } from './TagStore';

const ValidationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name')
});

export class TagEdit extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					name: this.props.tag.name
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'TagEdit')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns">
				<div className="column is-full">
					<FormField
						required
						className="has-text-left"
						label="Name"
						field="name"
						type="text"
						placeholder="Name"
					/>
				</div>
			</div>
		);
	}

	async save(values) {
		tagStore
			.update(this.props.tag.id, {
				tag: values
			})
			.then(result => {
				this.resultNotification(result, 'Tag', 'Edit');
			});
	}
}
